import ResendConfirmationScene from './ResendConfirmationScene'
export default ResendConfirmationScene